import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import { MapTrifold } from "@phosphor-icons/react";
import type { PanelState } from ".";
import type { MouseEvent } from "react";

interface HotelCardLocationToggleProps {
  handleToggleMap: (panel: PanelState) => (e: MouseEvent) => void;
  toggleMap: "open" | "close";
  locationLabel: string;
}

export default function HotelCardLocationToggle({
  handleToggleMap,
  toggleMap,
  locationLabel,
}: HotelCardLocationToggleProps) {
  return (
    <Flex
      onClick={handleToggleMap("map")}
      gap={"2"}
      alignItems={"center"}
      className="rounded-full p-1 px-2 cursor-pointer group"
    >
      <MapTrifold
        size={18}
        weight={toggleMap === "open" ? "fill" : "regular"}
        className="md:w-6 md:h-6 cursor-pointer text-foreground group-hover:text-primary transition duration-75 ease-in-out"
      />
      <Typography
        variant="caption"
        fontWeight="normal"
        className="text-foreground md:text-sm group-hover:text-primary transition duration-75 ease-in-out"
      >
        {locationLabel}
      </Typography>
    </Flex>
  );
}
